<div
  class="search-selection-basket"
  (click)="$event.stopPropagation()"
  (keydown)="null"
>
  <div class="search-selection-basket__top">
    <div class="search-selection-basket__top-headline">
      <span>
        {{ 'TRANS__SELECTION_BASKET__YOUR_CHOICES' | translate }}
      </span>

      <span class="search-selection-basket__top-headline-count">
        ({{selectedCount}})
      </span>
    </div>

    <a
      (click)="removeAll()"
      class="light-gray-color"
    >
      <span>
        {{ 'TRANS__SELECTION_BASKET__REMOVE_ALL' | translate }}
      </span>
    </a>
  </div>

  <hr>

  <div class="search-selection-basket__content">
    @if (selectedItems.length) {
      <ng-container>
        <mat-accordion multi="false">
          @for (item of selectedItems; track $index) {
            <mat-expansion-panel
              class="search-selection-basket__expansion-panel"
              (opened)="item.$$panelState = true"
              (closed)="item.$$panelState = false"
              [hideToggle]="true"
            >
              <mat-expansion-panel-header>
                <div class="search-selection-basket__indicator">
                  <mat-icon>
                    {{item.$$panelState ? 'expand_less' : 'expand_more'}}
                  </mat-icon>
                </div>

                <div
                  class="search-selection-basket__name"
                  [class.text-dark-primary]="item.$$panelState"
                >
                  <i class="{{item.icon}} text-dark-primary"></i>

                  <span>
                    {{item.artifact_name}}
                  </span>
                </div>

                <div class="search-selection-basket__remove">
                  <a
                    (click)="remove(item); $event.stopPropagation();"
                    class="light-gray-color"
                  >
                    <span>
                      {{ 'TRANS__SELECTION_BASKET__REMOVE' | translate }}
                    </span>
                  </a>
                </div>
              </mat-expansion-panel-header>

              <div class="search-selection-basket__overview-fields selection-dropdown-item__content">
                <div class="search-selection-basket__overview-fields__first-container">
                  @for (field of item.overview; track $index) {
                    <ng-container>
                      @if (field.items) {
                        <ng-container>
                          @for (item of field.items; track $index) {
                            <span class="search-selection-basket__overview-fields-item">
                              @if (item.field_values) {
                                <app-overview-field-item
                                  [fieldItem]="item"
                                  [disableLinks]="false"
                                  [last]="true"
                                  [toneDownTextColor]="false"
                                  class="search-selection-basket__field-value"
                                ></app-overview-field-item>

                                <span class="search-selection-basket__divider"></span>
                              }
                            </span>
                          }
                        </ng-container>
                      }
                    </ng-container>
                  }
                </div>

                <div class="search-selection-basket__overview-fields__second-container"></div>
              </div>
            </mat-expansion-panel>
          }
        </mat-accordion>

        <div class="search-selection-basket__bottom-menu">
          <span>
            {{start + selectedItems.length}} / {{selectedCount}}
          </span>

          <button
            mat-stroked-button
            color="primary"
            [disabled]="start === 0"
            (click)="prev()"
          >
            <span>
              {{ 'TRANS__SEARCH_SELECTION_BASKET__PREV' | translate }}
            </span>
          </button>

          <button
            mat-stroked-button
            color="primary"
            [disabled]="(start + selectedItems.length) === selectedCount"
            (click)="next()"
          >
            <span>
              {{ 'TRANS__SEARCH_SELECTION_BASKET__NEXT' | translate }}
            </span>
          </button>
        </div>
      </ng-container>
    }

    @if (!selectedItems.length && !loading) {
      <ng-container>
        <div class="search-selection-basket__empty-list">
          <span>
            {{ 'TRANS__SELECTION_BASKET__EMPTY_LIST' | translate }}
          </span>
        </div>
      </ng-container>
    }

    @else if (selectedItems.length !== selectedCount && loading) {
      <ng-container>
        <div class="search-selection-basket__loading">
          <span>
            {{ 'TRANS__SEARCH__LOADING_INFO' | translate }}
          </span>
        </div>
      </ng-container>
    }
  </div>
</div>
